import { render, staticRenderFns } from "./BillsPaymentFilter.vue?vue&type=template&id=18377770&"
import script from "./BillsPaymentFilter.vue?vue&type=script&lang=js&"
export * from "./BillsPaymentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports